<span
    mat-raised-button
    matTooltip="{{ tooltip.tooltipText }}"
    class="{{ tooltip.class }}">
        <span *ngIf="tooltip?.text">{{ tooltip.text }}</span>
        <mat-icon
            *ngIf="tooltip?.materialIcon"
            class="{{ tooltip.materialIconClass }}">
            {{ tooltip.materialIcon }}
        </mat-icon>
        <mat-progress-spinner
            *ngIf="tooltip?.isPreloader"
            mode="indeterminate"
            [diameter]="20"
            [color]="'accent'">
        </mat-progress-spinner>
</span>
